export default "__VITE_ASSET__Bja1yBbb__"